import { Check } from 'lucide-react';

const features = [
  {
    name: 'Connector-Based Integration',
    description: 'Spryker Commerce OS sends orders, revenue and customer data to Storyclash via a secure connector – no API key required.'
  },
  {
    name: 'Automated Updates',
    description: 'Keep dashboards synced with real-time Spryker order and creator attribution data.'
  },
  {
    name: 'B2B & B2C Unified Tracking',
    description: 'Track creator performance across both B2B marketplaces and B2C storefronts with one integration.'
  },
  {
    name: 'Multi-Workspace Support',
    description: 'Connect one Spryker store per workspace. Set up multiple workspaces to manage different stores or regional shops independently.'
  },
  {
    name: 'Enterprise Security',
    description: 'GDPR-compliant, EU-hosted, encrypted to enterprise standards, role-based access.'
  }
];

export default function SprykerFeaturesTable() {
  return (
    <section className="py-20" style={{ backgroundColor: '#FAFAFA', padding: '80px 24px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h2 className="text-center mb-16" style={{ fontSize: '36px', lineHeight: '1', fontWeight: '600', color: '#333333', fontFamily: 'Roboto, sans-serif' }}>
          Enterprise-Grade Features
        </h2>
        <div className="bg-white border-2 border-gray-100 overflow-hidden" style={{ borderRadius: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
          <div className="divide-y divide-gray-200">
            {features.map((feature, index) => (
              <div key={index} className="p-6 hover:bg-gray-50 transition-colors duration-200">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E5EAEC', borderRadius: '20px' }}>
                    <Check className="w-5 h-5" style={{ color: '#19B776' }} />
                  </div>
                  <div className="flex-1">
                    <h3 className="mb-2" style={{ fontSize: '18px', lineHeight: '1', fontWeight: '600', color: '#333333', fontFamily: 'Roboto, sans-serif' }}>
                      {feature.name}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: '1.3', fontWeight: '400', color: '#333333', fontFamily: 'Roboto, sans-serif' }}>
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
